import { NavLink, useHistory } from "react-router-dom";
import { cn } from "../../utils/bem";
import { absoluteURL } from "../../utils/helpers";

export const MenuItem = ({
  children,
  label,
  icon,
  to,
  className,
  href,
  exact = false,
  forceReload = false,
  active = false,
  isDangerous = false,
  onClick,
  ...rest
}) => {
  const history = useHistory();
  const rootClass = cn("main-menu", { elem: "item" });
  const classList = [rootClass.toClassName()];
  const isActive = (() => {
    const pathname = location.pathname.replace(/\/$/, "");
    const url = to ?? href;

    if (exact) {
      return pathname === url;
    }
    return pathname.includes(url);
  })();

  if (isActive || active) classList.push(rootClass.mod({ active: true }));

  if (isDangerous) classList.push(rootClass.mod({ dangerous: true }));

  if (className) classList.push(className);

  const linkContent = (
    <>
      {icon && <span className={rootClass.elem("item-icon").toClassName()}>{icon}</span>}
      {children ?? label}
    </>
  );

  const linkAttributes = {
    className: classList.join(" "),
    onClick,
    ...rest,
  };

  const activeClassName = rootClass.mod({ active: true }).toClassName();
  const finalHref = to ?? href;

  if (forceReload) {
    linkAttributes.onClick = () => (location.href = to ?? href);
  }

  // Capacitor: NavLink relies on react-router's click handler firing
  // before WKWebView consumes the click. On iOS that race occasionally
  // loses, leaving the WebView to resolve the anchor href against the
  // local file bundle (404) and — for some hrefs — popping Safari.
  // Drive the navigation explicitly through ``history.push`` so the
  // route change is purely client-side and never touches the WebView's
  // URL loader. Web/desktop fall through to the default NavLink path.
  const onCapacitor = typeof window !== "undefined" && typeof window.Capacitor !== "undefined";
  if (to && onCapacitor && !forceReload) {
    const userOnClick = linkAttributes.onClick;
    linkAttributes.onClick = (e) => {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      userOnClick?.(e);
      e.preventDefault();
      history.push(to);
    };
  }

  return (
    <li>
      {to ? (
        <NavLink to={finalHref} {...linkAttributes} exact={exact} activeClassName={activeClassName} data-external>
          {linkContent}
        </NavLink>
      ) : finalHref ? (
        <a href={absoluteURL(finalHref)} {...linkAttributes}>
          {linkContent}
        </a>
      ) : (
        <span {...linkAttributes}>{linkContent}</span>
      )}
    </li>
  );
};
